module.exports = __webpack_public_path__ + "static/img/online_doc_add.ddded62e.svg";